import { ApplicationRef, ApplicationConfig, Type, provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";

import { ApmService } from "@elastic/apm-rum-angular";

import { redactApmPayload } from "./apm-redaction.util";

export interface BootstrapApmOptions {
  appComponent: Type<unknown>; // Angular component class type
  appConfig: ApplicationConfig;
  environment: {
    apm: {
      serviceName: string;
      serverUrl: string;
      environment: string;
    };
  };
  serviceVersion: string;
  disableApmPredicate?: (hostname: string) => boolean;
}

function defaultDisablePredicate(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "localhost.v3.dev.lekto.com.br" ||
    hostname.endsWith(".local")
  );
}

export async function bootstrapWithApm(options: BootstrapApmOptions): Promise<ApplicationRef> {
  const { appComponent, appConfig, environment, serviceVersion, disableApmPredicate } = options;
  const predicate = disableApmPredicate ?? defaultDisablePredicate;

  const appRef = await bootstrapApplication(appComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...(appConfig.providers ?? [])]
  });

  if (!predicate(globalThis.location.hostname)) {
    // Enable APM only when predicate returns false (i.e., not disabled)
    try {
      const apmService = appRef.injector.get(ApmService);
      const apm = apmService.init({
        serviceName: environment.apm.serviceName,
        serverUrl: environment.apm.serverUrl,
        environment: environment.apm.environment,
        serviceVersion
      });
      // A chave de resgate do login social (e o code/state do callback OAuth) não deve chegar ao
      // Elastic: o filtro roda sobre todo payload antes do envio.
      apm.addFilter(redactApmPayload);
    } catch (err) {
      // Fail silently but log to console for debugging
      console.warn("APM initialization failed", err);
    }
  }

  return appRef;
}
